import React from "react";
import { ImageList, ImageListItem } from "@mui/material";

function ImageCard({ images }) {
  return (
    <ImageList
      sx={{
        maxHeight: "600px",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        margin: 0,
      }}
      cols={1}
      rowHeight={450}
      variant="woven"
    >
      {images.map((image, index) => (
        <ImageListItem>
          <img key={image} src={image} alt={`img_${index}`} loading="lazy" />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

export default ImageCard;
